import React from 'react';

class RangeInput extends React.Component {

  timeUnitOptions = [
    { label: 'Minutes', value: 1 * 60 * 1000 },
    { label: 'Hours', value: 60 * 60 * 1000 },
    { label: 'Days', value: 24 * 60 * 60 * 1000 },
    { label: 'Weeks', value: 7 * 24 * 60 * 60 * 1000 },
    { label: 'Months', value: 30 * 24 * 60 * 60 * 1000 },
    { label: 'Years', value: 12 * 30 * 24 * 60 * 60 * 1000 },
  ];

  render() {
    const { label, value, onChange } = this.props;
    const timeUnit = this.timeUnitOptions[2].value;
    const onChangeValue = value => onChange({ target: { value } });

    return (
      <div className='formInput'>
        <div className='flex flex-row'>
          <label>{label}</label>
          <input type='number' value={!value.from ? '' : value.from / timeUnit} min={0} onChange={e => onChangeValue({ from: e.target.value * timeUnit, to: +value.to })} style={{ minWidth: '60px', width: '60px' }} />
          <p style={{ margin: 'auto 5px', fontSize: 12, color: 'grey' }}>to</p>
          <input type='number' value={!value.to ? '' : value.to / timeUnit} min={0} onChange={e => onChangeValue({ from: +value.from, to: e.target.value * timeUnit })} style={{ minWidth: '60px', width: '60px' }} />
          <p style={{ margin: 'auto 5px', fontSize: 12, color: 'grey' }}>Days</p>
        </div>
      </div>
    );
  }
}

export default RangeInput;


// WEBPACK FOOTER //
// ./src/components/Form/RangeInput.js